/* eslint-disable no-param-reassign */
import { createAction, createReducer } from "@reduxjs/toolkit"
import _ from "lodash"
import httpClient from "./httpClient"
import appStore from "../appStore"

const WEBSITE_META = createAction("website/fetchMeta")
const SET_LOADING = createAction("website/setLoading")

function fetchMeta() {
  return (dispatch, getState) => {
    const { website } = getState()
    if (website.env.customer_name || website.isLoading) {
      // it means that it has been loaded once
      // or it is currently fetching the API
      return null
    }

    dispatch(SET_LOADING(true))
    return httpClient
      .get("/api/meta")
      .then(({ data }) => dispatch(WEBSITE_META(data)))
      .finally(() => dispatch(SET_LOADING(false)))
  }
}

function updateWebsiteMeta(settings) {
  if (!settings) {
    return null
  }

  return (dispatch, getState) => {
    const { env } = getState().website
    const mutableEnv = _.cloneDeep(env)
    _.set(mutableEnv, "contact", settings.contact)
    _.set(mutableEnv, "customer_name", settings.customer_name)
    _.set(mutableEnv, "website", settings.website)
    _.set(mutableEnv, "meta.title", settings.title)
    _.set(mutableEnv, "meta.og.title", settings.ogTitle)
    _.set(mutableEnv, "meta.og.description", settings.ogDescription)
    dispatch(WEBSITE_META(mutableEnv))
  }
}

const initialState = {
  isLoading: false,
  env: {
    website: undefined,
    customer_name: undefined,
    contact: undefined
  }
}
const reducer = createReducer(initialState, {
  "website/setLoading": (state, { payload }) => {
    state.isLoading = payload
  },
  "website/fetchMeta": (state, { payload }) => {
    state.env = payload
  }
})

appStore.injectReducer("website", reducer)

export default {
  actions: {
    fetchWebsiteMeta: fetchMeta,
    updateWebsiteMeta
  }
}
